function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#0B474B",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".16",
  d: "M8.09.266c.038.02.07.05.089.089l2.2 4.37 4.837.743a.199.199 0 01.11.339L11.85 9.251l.788 4.83a.2.2 0 01-.289.209L8 12.048V.245c.03 0 .06.006.09.021z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 .245v11.803L3.65 14.29a.2.2 0 01-.289-.21l.79-4.83L.673 5.808a.198.198 0 01.11-.339l4.837-.743 2.2-4.37A.201.201 0 018 .246z"
}))));